import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, EnvConfig } from '@doc/core';
import { Observable } from 'rxjs';
import { ApiUrls } from '../backoffice-urls';
import { BaseResponse, VenueDeleteRequest, VenueGetListRequest, VenueGetListResponse, VenueInsertRequest } from '../models';

@Injectable({
  providedIn: 'root'
})
export class VenueService {

  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
    private http: HttpClient
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getAllVenues(body: VenueGetListRequest) {
    const link = this.apiUrl + ApiUrls.getAllVenues;
    return this.http.post<VenueGetListResponse>(link, body);
  }

  getVenueDetails(id: any) {
    const link = this.apiUrl + ApiUrls.getVenueDetails;
    return this.http.get<any>(link +"/" + id);
  }

  deleteVenue(body: VenueDeleteRequest) {
    const link = this.apiUrl + ApiUrls.deleteVenue;
    return this.http.post<BaseResponse>(link, body);
  }

  insertVenue(body: FormData) {
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });
    const link = this.apiUrl + ApiUrls.insertVenue;
    return this.http.post<BaseResponse>(link, body,{headers:headers});
  }

  updateVenue(body: VenueInsertRequest) {
    const link = this.apiUrl + ApiUrls.updateVenue;
    return this.http.post<BaseResponse>(link, body);
  }

  getAllBlocks(body: any) {
    const link = this.apiUrl + ApiUrls.getAllBlocks;
    return this.http.post<any>(link, body);
  }
}
